import React from 'react';
import { Crown, AlertCircle } from 'lucide-react';

const RoyaltyStatus = ({ isEligible, requirements }) => {
  // Create description based on what requirements are not met
  const getDescription = () => {
    if (isEligible) {
      return 'You will receive a share of the global royalty pool in the next distribution.';
    }
    
    let description = 'To qualify, you need to:';
    if (!requirements.minInvestmentMet) description += ' Invest $100+,';
    if (!requirements.minReferralsMet) description += ' Have 2+ direct referrals,';
    if (!requirements.qualifiedRefsMet) description += ' Have 2+ referrals with $100+ investment each,';
    return description.slice(0, -1); // Remove trailing comma
  };

  return (
    <div className="royalty-status-box">
      <div className="royalty-icon">
        {isEligible ? <Crown size={30} /> : <AlertCircle size={30} />}
      </div>
      <div className="royalty-status-content">
        <h2>{isEligible 
          ? 'Congratulations! You are eligible for Royalty Pool' 
          : 'You are not yet eligible for Royalty Pool'}
        </h2>
        <p>{getDescription()}</p>
      </div>
    </div>
  );
};

export default RoyaltyStatus;
